import React from 'react';
import { SvgIcon } from '@material-ui/core'

const TravelerCoverage = (props) => (
  <SvgIcon
    viewBox="0 0 30.678 40.904"
    {...props}
  >
    <path 
      d="M301.914,271.652h-3.835V262.7a3.835,3.835,0,0,0-3.834-3.835h-7.67a3.835,3.835,0,0,0-3.835,3.835v8.948h-3.835a3.835,3.835,0,0,0-3.835,3.835v17.9a3.835,3.835,0,0,0,3.835,3.835h1.278v1.278a1.278,1.278,0,0,0,1.279,1.278h2.556a1.278,1.278,0,0,0,1.279-1.278v-1.278h10.226v1.278a1.277,1.277,0,0,0,1.278,1.278h2.557a1.278,1.278,0,0,0,1.278-1.278v-1.278h1.278a3.835,3.835,0,0,0,3.835-3.835v-17.9A3.835,3.835,0,0,0,301.914,271.652ZM285.3,262.7a1.28,1.28,0,0,1,1.278-1.278h7.67a1.28,1.28,0,0,1,1.278,1.278v8.948H285.3Zm17.894,30.678a1.28,1.28,0,0,1-1.278,1.278H278.906a1.28,1.28,0,0,1-1.278-1.278v-17.9a1.28,1.28,0,0,1,1.278-1.278h23.008a1.28,1.28,0,0,1,1.278,1.278Zm-5.752-6.391H283.38a.639.639,0,0,0-.639.639v1.278a.639.639,0,0,0,.639.639H297.44a.639.639,0,0,0,.639-.639V287.63A.639.639,0,0,0,297.44,286.991Zm0-7.67H283.38a.639.639,0,0,0-.639.639v1.278a.639.639,0,0,0,.639.639H297.44a.639.639,0,0,0,.639-.639V279.96A.639.639,0,0,0,297.44,279.321Z" 
      transform="translate(-275.071 -258.869)"
    />
  </SvgIcon>
);

export default TravelerCoverage;